// Swiperインスタンスを管理する変数
let mainSwiper = null;

// Swiperスライドショーの初期化関数
function initMainSwiper() {
  // 既存のインスタンスがあれば破棄
  if (mainSwiper) {
    mainSwiper.destroy(true, true);
    mainSwiper = null;
  }

  // 対象要素が存在するか確認
  const swiperElement = document.querySelector('#slides .swiper, #mainImages');
  if (!swiperElement) {
    return;
  }

  // Swiperライブラリが読み込まれているか確認
  if (typeof Swiper === 'undefined') {
    setTimeout(initMainSwiper, 50);
    return;
  }

  // Swiperスライドショーの初期化（PC版とSP版対応）
  mainSwiper = new Swiper('#slides .swiper, #mainImages', {
    // 基本設定
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },

    // フェード効果
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },

    // ページネーション
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },

    // ナビゲーションボタン
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    // スライド切り替え速度
    speed: 350,

    // 初期化完了時のコールバック
    on: {
      init: function() {
      },
    },
  });
}

// DOMContentLoadedイベントで初期化
document.addEventListener('DOMContentLoaded', initMainSwiper);
